import React, {useState, ReactNode} from 'react';
import './ExpandableText.css';
import {useMediaQuery, useTheme} from "@mui/material";

interface ExpandableTextProps {
    children: ReactNode;
    maxHeight?: number;
}

const ExpandableText: React.FC<ExpandableTextProps> = ({children, maxHeight = 200}) => {
    const [expanded, setExpanded] = useState(false);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <div className="ExpandableText">
            <div
                className="ExpandableText-content"
                style={{
                    maxHeight: expanded || !isMobile ? 'none' : `${maxHeight}px`,
                    overflow: expanded || !isMobile ? 'visible' : 'hidden'
                }}
            >
                {children}
            </div>
            {isMobile && <span onClick={() => setExpanded(!expanded)} className="ExpandableText-link">{expanded ? 'סגור' : 'לקרוא עוד >'}</span>}
        </div>
    );
};

export default ExpandableText;
